module.exports = {
  image: {
    key: 'image',
    label: 'Image',
  },
  text: {
    key: 'text',
    label: 'Text',
  },
  pdf: {
    key: 'pdf',
    label: 'Pdf',
  },
  video: {
    key: 'video',
    label: 'Video',
  },
  videoLink: {
    key: 'videoLink',
    label: 'Video Link',
  },
};